// temporary util for testing until BE returns relativeUrls
export const getRelativeUrl = (url: string) => url.replace(/^(?:https?:)?\/\/[^/]+/, '');
